module.exports = __webpack_public_path__ + "img/glasstype-screen.5cfeb36c.svg";